import { render } from "./RecoveryCodes.vue?vue&type=template&id=378a21ef&scoped=true"
import script from "./RecoveryCodes.vue?vue&type=script&lang=js"
export * from "./RecoveryCodes.vue?vue&type=script&lang=js"

import "./RecoveryCodes.vue?vue&type=style&index=0&id=378a21ef&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378a21ef"]])

export default __exports__